"use strict";

exports.__esModule = true;
exports.createTableColumns = createTableColumns;
var _AdvancedDataTableColumn = require("../AdvancedDataTableColumn");
function createTableColumns(columns) {
  return columns.map(function (column) {
    return _AdvancedDataTableColumn.AdvancedDataTableColumnWidget.createElement(Object.assign({
      hideTypeSelector: true,
      canFilter: false
    }, column));
  });
}